import React, { useState } from "react";
import { ArrowRight } from "lucide-react";

export const LoginScreen = ({ onSubmit, error }) => {
  const [value, setValue] = useState("");
  const submit = (e) => {
    e.preventDefault();
    if (value.trim()) onSubmit(value.trim());
  };
  return (
    <div className="min-h-screen bg-[#0F1B2D] text-white flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-4">
          <img src="/nc-logo.png" alt="Northcrest" className="h-14 w-auto" />
          <div className="leading-[1.05]">
            <div className="font-display text-white tracking-[0.32em] text-base">NORTHCREST</div>
            <div className="font-display text-[#C4A46A] tracking-[0.5em] text-[10px]">ATHLETICS</div>
          </div>
        </div>
        <h1 className="mt-10 font-display text-3xl tracking-tight">Admin Console</h1>
        <span className="gold-rule mt-4 block" />
        <p className="mt-6 text-white/70 text-sm">Enter your admin key to access registrations, consultations and newsletter data.</p>
        <form className="mt-8" onSubmit={submit}>
          <label className="overline text-white/50">Admin Key</label>
          <input
            type="password"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            data-testid="admin-key-input"
            autoFocus
            className="mt-2 w-full bg-transparent border-0 border-b border-white/25 focus:border-[#C4A46A] focus:outline-none py-3 text-white placeholder:text-white/40"
            placeholder="Paste your key"
          />
          {error && <p className="mt-3 text-[#D96A6A] text-sm" data-testid="admin-login-error">{error}</p>}
          <button
            type="submit"
            data-testid="admin-login-submit"
            className="mt-8 inline-flex items-center gap-3 px-8 py-3 bg-[#C4A46A] text-[#0F1B2D] text-[11px] tracking-[0.24em] uppercase font-bold hover:bg-[#A38755] transition-colors"
          >
            Enter <ArrowRight size={14} />
          </button>
        </form>
      </div>
    </div>
  );
};
